import React, { Component } from "react";
import { Form, Message } from "semantic-ui-react";

import request from "../../../utils/request";
import set from "lodash/set";

class Sellers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      xhrResponse: {
        success: null,
        message: ""
      },
      locations: [],
      sellers: [],
      isAddon: props.isAddon
    };
  }
  componentDidMount = () => {
    this.rules = {};

    let self = this;
    let promises = [
      request.list(this, "api:/location", { limit: 0 }), // request all locations
      request.get(this, `api:/event-sellers/${this.props.eventId}`)
    ];

    Promise.all(promises).then(function(values) {
      self.setLocationList(values[0]);
      self.setSellerList(values[1]);
      self.setState({ isLoading: false });
    });
  };
  setLocationList = result => {
    let data = [];
    if (result.data.length > 0) {
      result.data.map((value, index) =>
        data.push({
          text: value.name,
          value: value.id,
          id: value.id
        })
      );
    }
    this.setState({
      locations: data
    });
  };
  setSellerList = result => {
    let data = [];
    result.data.map((value) => {
      if (+value.volunteer_id === 50000 || value.login === "shopify" || value.volunteer === "ALL RSUs"||  value.volunteer_role === "external_seller") return false;
      return data.push({
        text: value.volunteer,
        value: value.volunteer_id,
        login: value.login,
        id: value.utv_id,
        active: 1,
        location_id: value.location_id,
        float: value.cash_float,
        cash_drops: value.cash_drops,
        notes: value.notes
      });
    });
    this.setState({
      sellers: data
    });
  };
  handleChange = (e, { name, value, checked }) => {
    if (checked === false) {
      value = "0";
    }

    let data = this.state;
    set(data, name, value);
    this.setState(data);
  };
  handleData = e => {
    this.handleSubmit(e);
  }
  handleSubmit = e => {
    e && e.preventDefault();
    let { eventId } = this.props;
    let { sellers } = this.state;
    let sellersParam = [];
    sellers.map(value => {
      if (value.active === 1 || value.id > 0) {
        sellersParam.push(value);
      }
      return value;
    });
    request
      .post(this, `api:/event-sellers`, {
        event_id: eventId,
        sellers: sellersParam
      })
      .then(resp => {
        this.setState({
          xhrResponse: resp,
        });
        return request.get(this, `api:/event-sellers/${eventId}`, {});
      });
  };
  render() {
    const {
      isLoading,
      sellers,
      locations,
      isAddon,
      xhrResponse
    } = this.state;
    return (
      <Form
        size="large"
        error={!xhrResponse.success && xhrResponse.success !== null}
        success={xhrResponse.success}
        loading={isLoading}
      >
        <Message
          error
          content={xhrResponse.message}
        />
        <Message
          success
          content={xhrResponse.message}
        />
        {Object.keys(sellers).map((v, k) => {
          let seller = sellers[k];
          if (seller.active > 0)
          return (
            <Form.Group key={k}>
              <label basic={"true"} style={{width: 100, marginTop: (k === 0) ? 35 : 10}}>{seller.text}</label>
              <Form.Select
                name={"sellers[" + k + "].location_id"}
                options={locations}
                label={k === 0 ? "Location" : ""}
                value={sellers[k].location_id}
                width={3}
                compact
                onChange={this.handleChange}
                disabled={isAddon}
              />
              <Form.Input
                type="number"
                min="0"
                label={k === 0 ? "Float" : ""}
                name={"sellers[" + k + "].float"}
                value={sellers[k].float}
                width={3}
                onChange={this.handleChange}
              />
              <Form.Field width={3}>
                <label basic={"true"} style={{width: 100}}>{k === 0 ? "Cash Drops" : ""}</label>
                <Form.Input
                  type="number"
                  min="0"
                  name={"sellers[" + k + "].cash_drops"}
                  value={sellers[k].cash_drops}
                  onChange={this.handleChange}
                  disabled={true}
                />
              </Form.Field>
              <Form.Input
                min="0"
                label={k === 0 ? "Notes" : ""}
                name={"sellers[" + k + "].notes"}
                value={sellers[k].notes}
                width={3}
                onChange={this.handleChange}
              />
            </Form.Group>
          );
          return null;
        })}
      </Form>
    );
  }
}

export default Sellers;
